const resourceMutationKeys = {
  createResource: [
    "create-resource"
  ]
};

export { resourceMutationKeys };
//# sourceMappingURL=resourceMutationKeys.js.map
